<ng-container *skAutorun><div class="sk-rich-text-content" [innerHTML]="html"></div></ng-container>